import React from "react";
import {
	Avatar,
	Box,
	Container,
	Flex,
	Heading,
	IconButton,
	Img,
	Link,
	ListItem,
	Text,
	UnorderedList,
} from "@chakra-ui/react";
import { FaLinkedin } from "react-icons/fa";

const TheContextPortfolioBlog: React.FC = () => (
	<>
		<Flex
			flexDirection="column"
			overflow="hidden"
			justify="center"
			height="100%"
			py={{ xs: "30px", sm: "40px", md: "60px", lg: "80px" }}
			h="100%"
			minH={{ xs: "400px", lg: "400px" }}
			maxH={{ xs: "400px", lg: "400px" }}
			pos="relative"
		>
			<Img
				pos="absolute"
				objectFit="cover"
				src="/webp/theContext-bg.webp"
				alt="members-hero"
				height="100%"
				width="100%"
			/>
			<Box
				bg="linear-gradient(78.35deg, rgba(13, 96, 81, 0.8) 18.38%, rgba(83, 92, 143, 0.8) 86.05%)"
				pos="absolute"
				height="100%"
				width="100%"
				opacity="0.7"
			/>
			<Container
				display="flex"
				as="section"
				maxW="container.xl"
				position="relative"
				zIndex="1"
				flexDir={{ xs: "column", md: "row" }}
				columnGap="24px"
				rowGap="30px"
				alignItems={{ xs: "flex-start", md: "flex-start" }}
				px={{ xs: "14px", sm: "28px", md: "45px", lg: "60px", xl: "inherit" }}
			>
				<Flex flexDir="column" rowGap="16px">
					<Heading
						color="white"
						fontSize={{ xs: "36px", sm: "42px", lg: "64px" }}
						fontWeight="800"
						lineHeight={{ xs: "35px", lg: "83px" }}
					>
						#TheContext
					</Heading>
					{/* <Heading
            color="white"
            fontSize={{ xs: '28px', sm: '34px' }}
            fontWeight="500"
            lineHeight="32px"
          >
            - By IVCA
          </Heading> */}
				</Flex>
				<Box
					w="1.5px"
					h={{ md: "200px", lg: "300px", xl: "230px" }}
					bgColor="white"
					display={{ xs: "none", md: "block" }}
				/>
				<Box
					w={{ xs: "70%", sm: "60%" }}
					h="1.5px"
					bgColor="white"
					display={{ xs: "block", md: "none" }}
				/>
				<Flex flexDir="column" rowGap="8px">
					<Heading
						as="h1"
						mb={{ xs: "10px", md: "20px" }}
						variant="reportCardTitle"
						fontSize={{ xs: "27px", sm: "29px", md: "32px", lg: "44px" }}
						color="white"
						lineHeight={{ xs: "36px", sm: "40px", md: "46px", lg: "70.2px" }}
					>
						Empowering Future Fund Managers: Insights on Portfolio Management,
						Governance, Exits, and Returns
					</Heading>
					<Text
						fontSize={{ xs: "18px", sm: "18px", md: "20px", lg: "22px" }}
						fontWeight="600"
						color="white"
						lineHeight="28px"
					>
						Rajat Tandon
					</Text>
				</Flex>
			</Container>
		</Flex>
		<Container maxW="container.xl" pb="80px" pt="40px">
			<Flex
				flexDir={{ xs: "column-reverse", md: "row" }}
				px={{ xs: "8px", md: "0px" }}
			>
				<Flex
					w={{ xs: "100%", md: "27%" }}
					mt={{ xs: "32px", md: "0px" }}
					flexDir="column"
					rowGap="16px"
					mr={{ xs: "0px", md: "40px" }}
					ml={{ xs: "0px", sm: "10px" }}
					mb={{ xs: "16px", md: "8px" }}
				>
					<Heading
						fontSize="22px"
						lineHeight="22px"
						textAlign={{ xs: "center", sm: "left" }}
					>
						Follow the Author
					</Heading>
					<Box
						w="100%"
						h="1.5px"
						bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
						my="8px"
					/>
					{[
						{
							name: "Rajat Tandon",
							position: "President, IVCA",
							linkedin: "https://www.linkedin.com/in/rajat-tandon-india/",
							image:
								"https://static.levocdn.com/WGLBUT82/7081933215524045374.jpeg",
						},
					].map((item, index) => (
						<Flex
							key={index}
							flexDir={{ xs: "column", sm: "row", md: "column" }}
							columnGap="20px"
							rowGap="16px"
						>
							<Flex
								flexDir="column"
								alignItems={{ xs: "center", sm: "flex-start" }}
								rowGap="8px"
							>
								<Box boxSize="95px" borderRadius="50%" overflow="hidden">
									<Avatar
										name={item.name}
										w="100%"
										h="100%"
										src={item.image}
										objectFit="cover"
									/>
								</Box>
								<Flex flexDir="column" rowGap="4px">
									<Heading
										variant="blogQuestion"
										textAlign={{ xs: "center", sm: "left" }}
									>
										{item.name}
									</Heading>
									<Text
										variant="blogAnswer"
										textAlign={{ xs: "center", sm: "left" }}
										fontStyle="italic"
									>
										{item.position}
									</Text>
								</Flex>
								<Flex
									columnGap={{ xs: "4px", md: "16px" }}
									justifyContent={{ xs: "center", sm: "flex-start" }}
									transform={{ xs: "translateX(12px)", sm: "none" }}
								>
									<Box alignSelf="center">
										<Link href={item.linkedin} target="_blank">
											<IconButton
												aria-label="linkedin"
												icon={
													<FaLinkedin
														size="28px"
														color="rgba(100, 100, 140, 0.6)"
													/>
												}
												variant="unstyled"
												cursor="pointer"
											/>
										</Link>
									</Box>
								</Flex>
							</Flex>
						</Flex>
					))}
				</Flex>

				<Box w={{ xs: "100%", md: "73%" }}>
					<Text variant="blogAnswer" mb="20px">
						Breaking into venture capital industry isn’t easy. It demands a
						unique blend of skills, an unyielding hustle culture, and the
						ability to wear multiple hats. First-time fund managers (FTFMs) are
						underestimated due to their lack of track record but they are the
						ones who bring fresh perspective to venture. With their feet on
						ground approach, FTFMs take tough decisions, forge relationships,
						identify promising portfolio companies, and work tirelessly to
						support the growth of these enterprises.
					</Text>
					<Text variant="blogAnswer" pb="20px">
						Developing from this insight and recognizing the meteoric rise of
						micro-VCs and first-time fund managers (FTFMs) in India in the
						recent times – #VC101 by IVCA in partnership with PwC and IC
						Universal Legal, has become the sought after learning platform for
						decoding trade secrets, learning about the tax and legal compliance
						requirements and overall management of a successful venture fund. As
						a FTFM the process of setting up a fund, building relationships and
						fundraising from LPs, and hiring an A-Team is quite daunting. Adding
						to this mix is the tireless journey of identifying high growth
						potential companies while incorporating as many touch-points to help
						their investments to succeed.
					</Text>
					<Text variant="blogAnswer" pb="20px">
						After stupendous success of the first two sessions of #VC101 in
						Mumbai and Bengaluru, we are excited for the third and the final
						session in New Delhi. This session has been carefully designed and
						will focus on Portfolio management, governance, LP reporting, exits
						and n+1 fund strategies. If you are a FTFM and want to learn from
						the best in the industry, you should apply soon as few seats are up
						for grabs! Keep reading to know what one should expect at the Delhi
						session of #VC101.
					</Text>
					<UnorderedList>
						<ListItem mb="4px">
							<Text fontWeight="bold" variant="blogAnswer" pl={{ md: "12px" }}>
								Portfolio Management: Balancing Risk and Reward
							</Text>
						</ListItem>
						<Text
							mb="14px"
							variant="blogAnswer"
							pl={{ md: "12px", lg: "18px" }}
						>
							A fund manager’s sharp focus on portfolio management gives him/her
							the competitive advantage. A well-defined portfolio management
							helps the fund manager to determine the exit strategy with the
							focus on maximizing returns and minimizing risks. An informed VC
							can provide insights and advice to companies to improve their
							performance metrics. Therefore, the third module of #VC101 in
							Delhi will dive deep into the art of building and managing a
							diversified portfolio. Mentors will share valuable insights on
							evaluating investment opportunities, conducting due diligence, and
							find metrics which help you make some hard calls that align with
							your investment thesis and risk appetite.
						</Text>
						<ListItem mb="4px">
							<Text fontWeight="bold" variant="blogAnswer" pl={{ md: "12px" }}>
								Governance: Cultivating Sustainable Growth
							</Text>
						</ListItem>
						<Text
							mb="14px"
							variant="blogAnswer"
							pl={{ md: "12px", lg: "18px" }}
						>
							Good governance in the start-up-VC ecosystem is an essential part
							of the day-to-day operations. Internal checks and balances can
							help companies to mitigate financial and operational risk, improve
							efficiency, prevent fraud, and comply with laws and regulations.
							Neglecting internal controls can be costly and detrimental to the
							long-term health and well-being of a portfolio company and can
							contribute to business failure and increase the risk of fraud. Up
							until now there has been little information on what constitutes
							good governance. With the recent launch of the{" "}
							<Link
								as="a"
								href="https://www.ivca.in/resources/recent-reports/start-up-playbook"
								target="_blank"
								style={{ color: "blue", textDecoration: "underline" }}
							>
								Start-up Governance Playbook
							</Link>
							, we have a session designed to provide a comprehensive
							understanding of corporate governance best practices and their
							implications for portfolio companies.
						</Text>
						<ListItem mb="4px">
							<Text fontWeight="bold" variant="blogAnswer" pl={{ md: "12px" }}>
								LP Reporting, Exits and n+1 fund strategies
							</Text>
						</ListItem>
						<Text
							mb="14px"
							variant="blogAnswer"
							pl={{ md: "12px", lg: "18px" }}
						>
							Maintaining strong relationships with Limited Partners (LPs) is
							paramount for FTFMs. By providing comprehensive and transparent LP
							reporting, FTFMs instil confidence in their investors. Regular
							updates on fund performance, investment progress, and financial
							metrics allow LPs to assess the fund&apos;s progress and make
							informed decisions.
						</Text>
					</UnorderedList>
					<Text variant="blogAnswer" mb="20px">
						There are currently &gt; 140,000 venture capital-backed companies
						worldwide. Although the success ratio of these companies to provide
						a significant value at the time of exit remains small; the exit
						strategy is an integral part of the venture capital journey. We will
						have industry experts from IC Universal Legal, PwC and investors in
						the room to guide fund managers through the intricacies of timing
						exits, creating exit plans, and nurturing relationships with
						potential acquirers. A well-executed exit not only unlocks value for
						investors but also fuels the growth and expansion of portfolio
						companies.
					</Text>
					<Text variant="blogAnswer" mb="20px">
						While financial returns are undoubtedly important, I encourage FTFMs
						to embrace a broader perspective on returns. Discussions lined up at
						the Delhi session will delve into the concept of impact investing -
						where investors seek to generate both financial and societal
						returns. It will help them explore how investments in start-ups that
						address critical challenges can create positive social change while
						delivering attractive financial gains. By considering the potential
						societal impact of investments, FTFMs can contribute to building a
						more inclusive and sustainable future.
					</Text>
					<Text variant="blogAnswer" mb="20px">
						FTFMs must always be forward-thinking and consider the implications
						of their current fund on their next fundraising cycle. By
						strategically allocating capital, cultivating relationships, and
						demonstrating a solid track record, FTFMs can attract potential
						investors for future funds. Effectively executing n+1 fund
						strategies ensure a smooth transition between fundraising cycles,
						minimizes disruption, and provides a continuous stream of capital to
						support future investments.
					</Text>
					<Text variant="blogAnswer" pb="20px">
						The maiden edition of the #VC101 has been a true nation-wide
						masterclass journey which has been able to gather enough steam since
						its launch in the early part of June this year. Two cities down and
						the final module planned in Delhi, #VC1O1 has carved a space with
						this peer-to-peer model of learning for FTFMs to help them build
						their winning strategy. We are ecstatic for the Delhi module which
						will be a packed day with a line-up of thought-provoking and
						interactive sessions and offer ample opportunities to network with
						peers and mentors.{" "}
						<Link
							as="a"
							href="https://www.ivca.in/vc-101"
							target="_blank"
							style={{ color: "blue", textDecoration: "underline" }}
						>
							Apply soon
						</Link>{" "}
						as the seats are filling up fast. Should you have queries, IVCA team
						will be happy to discuss and receive feedback. Feel free to reach
						out to either{" "}
						<Link
							as="a"
							href="mailto:amit.pandey@ivca.in"
							target="_blank"
							style={{ color: "blue", textDecoration: "underline" }}
						>
							amit.pandey@ivca.in
						</Link>{" "}
						or{" "}
						<Link
							as="a"
							href="mailto:sunitha@ivca.in"
							target="_blank"
							style={{ color: "blue", textDecoration: "underline" }}
						>
							sunitha@ivca.in
						</Link>
						.
					</Text>
				</Box>
			</Flex>
			<Box w="100%" h="1.5px" mt="16px" mb="8px" bgColor="gray.700" />
			<Text variant="blogAnswer" fontStyle="italic" p="12px 12px 0px">
				<Heading variant="blogQuestion" fontStyle="normal" as="span">
					#TheContext by IVCA{" "}
				</Heading>
				– features opinion makers from the alternate investing industry with
				strong focus on India as investment destination. Watch this space for
				viewpoints on investment themes, emerging trends, economic analysis and
				latest industry insights.
			</Text>
			<Heading
				variant="blogQuestion"
				lineHeight="30px"
				pt="16px"
				fontStyle="italic"
				p="12px 12px 0px"
			>
				Content in this section is curated by team IVCA. To share feedback,
				connect with &nbsp;
				<Link
					href="mailto:paromita.sinha@ivca.in"
					target="_blank"
					style={{ color: "blue", textDecoration: "underline" }}
				>
					paromita.sinha@ivca.in
				</Link>
			</Heading>
		</Container>
	</>
);

export default TheContextPortfolioBlog;
